import React, { Component } from 'react';
import { StepPage } from '../../controls/StepPage';
import { BaseCombobox } from '../../controls/BaseCombobox';
import { BaseTextBox } from '../../controls/BaseTextBox';
import { FormattedMessage } from 'react-intl';
import orderService from '../OrderService';

export class EarmoldStep4Page extends StepPage {    
    constructor(props) {
        super(props);
        let version = props.model.earmoldVersion;
        let type = props.model.bteOrRic;
           
        let versions = orderService.GetCurrentEarmoldVersionOptionSettings(type);
        let selectedVersion = null;
        if (version) {
            let arr = version.split(',');
            if (arr.length == 2) {
                let code = arr[1];
                selectedVersion = versions.find(x => x.value === code);               
            }            
        }
        if (!selectedVersion) {
            selectedVersion = versions[0];
            props.model.earmoldVersion = selectedVersion.label + ',' + selectedVersion.value;
        }

        this.state = { versions: versions, selectedVersion: selectedVersion }
        this.handleValueSeleted = this.handleValueSeleted.bind(this);
    }

    handleValueSeleted(e) {
        let target = e.target;
        let value = target.value;

        let selectVersion = null;
        let versions = this.state.versions;
        for (var i = 0; i < versions.length; i++) {
            if (value === versions[i].value) {
                selectVersion = versions[i];
                break;
            }
        }
        if (selectVersion) {
            this.props.model.earmoldVersion = selectVersion.label + ',' + value;
        }
        this.setState({ selectedVersion: selectVersion });
    }

    validate() {
        ////TODO
        return { state: true, msg: "todo check page4" };
    }

    render() {
        let model = this.props.model;
        if (!model) {
            return null;
        }
        let type = model.bteOrRic;
        let versions = this.state.versions;
        let selectedVersion = this.state.selectedVersion;
        if (type === "RIC" || type === "IF") {
            return <div className="flex gap-6">
                <div className="w-auto">
                    <div className="w-full">
                        <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="EarmoldVersion" /></label>
                        <div className="flex mt-1">
                            <BaseCombobox onChangeCapture={this.handleValueSeleted}>
                                {versions.map(o => <option key={o.value} value={o.value} selected={selectedVersion.value === o.value}>{o.label}</option>
                                )}
                            </BaseCombobox>                            
                        </div>                        
                    </div>
                    <div className="mt-2">
                        <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="Code" /></label>
                        <BaseTextBox type="text" classnames="mt-1" readOnly="readOnly" value={selectedVersion.value} />
                    </div>
                </div>
                <div className="flex flex-col">
                    <label className="text-transparent">note</label>
                    {selectedVersion && <label className="font-bold text-red-600 w-full mt-2">{selectedVersion.note} </label>}
                </div>
            </div>
        }
        return <div className="flex gap-6">
            <div className="">
                <div className="">
                    <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="EarmoldVersion" /></label>
                    <div className="flex mt-1">
                    <BaseCombobox classnames="mt-1" onChangeCapture={this.handleValueSeleted}>
                            {versions.map(o => <option key={o.value} value={o.value} selected={selectedVersion.value === o.value}>{o.label}</option>
                        )}                        
                        </BaseCombobox>                       
                    </div>
                </div>
                <div className="mt-2">
                    <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="Code" /></label>
                    <BaseTextBox type="text" classnames="mt-1" readOnly="readOnly" value={selectedVersion.value} />
                </div>
            </div>
            <div className="flex flex-col">
                <label className="text-transparent">note</label>
                {selectedVersion && <label className="font-bold text-red-600 w-full mt-2">{selectedVersion.note} </label>}
            </div>            
        </div>
    }
}
